<template>
    <div class="p-4 flex-1 d-flex flex-column overflow-auto">
        <v-row>
            <v-col cols="6">
                <div style="font-size: 18px; margin-bottom: 5px;">{{$t('res_Label_AvailableActions')}}</div>
                <v-text-field v-model="search" :label="$t('res_ButtonText_Search')" solo style="padding-bottom: 5px;"></v-text-field>
                <div class="">
                    <Container group-name="1" :get-child-payload="getChildPayload2" class="list-box" style="min-height: 300px; max-height: 300px;"
                        @drop="onDropAssignedAction('assignedActions', $event)">
                        <Draggable v-for="item in assignedActions" :key="item.id" >
                            <div class="draggable-item" v-if="item.data.toLowerCase().includes(search.toLowerCase())">
                                {{ item.data }}
                            </div>
                        </Draggable>
                    </Container>
                </div>
            </v-col>
            <v-col cols="6">
                <div style="font-size: 18px; margin-bottom: 5px;">{{$t('res_Label_AssignedActions')}}</div>
                <v-text-field v-model="seacrhvalue" :label="$t('res_ButtonText_Search')" solo style="padding-bottom: 5px;"></v-text-field>
                <div class="">
                    <Container group-name="1" :get-child-payload="getChildPayload1" class="list-box" style="min-height: 300px; max-height: 300px;"
                        @drop="onDropAction('actions', $event)">
                        <Draggable v-for="item in actions" :key="item.id">
                            <div class="draggable-item" v-if="item.data.toLowerCase().includes(seacrhvalue.toLowerCase())">
                                {{ item.data }}
                            </div>
                        </Draggable>
                    </Container>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import constants from "@/assets/js/constants";
    import axios from "axios"
    import { Container, Draggable } from "vue-smooth-dnd"

    export default {
        components: { Container, Draggable },
        props: 
        { 
            roleId: { type: Number, default: 0 },
            applicationId: { type: Number, default: 0},
            search: "",
            seacrhvalue:"",
            userId:{ type: Number, default: 0 },
        },
        data() {
            return {
                actions: [],
                assignedActions: [],
                roleName: "",
                search: "",
                seacrhvalue:"",
            };
        },
        created() {
            this.getActions(10, i => ({ id: i, data: "Draggable_" + i }))
        },
        watch:
        {
            roleId: function(){
                this.getActions();
            },
            userId: function(){
                this.getActions();
            },
            applicationId: function(){
                this.getActions();
            },  
        },

        methods: {
            async getActions() {
                try {
                    const reqActions = await axios.get(`${constants.baseApiUrl}ActionSecurity/GetAllAvailableActions?roleId=${this.roleId}&applicationId=${this.applicationId}&userId=${this.userId}`);
                    //
                    const receivedActions = reqActions.data.actions;
                    this.actions = receivedActions.filter(act => act.isAssigned).map(act => ({ data: act.typeName + " - " + act.name, id: act.id }))
                    this.assignedActions = receivedActions.filter(act => !act.isAssigned).map(act => ({ data: act.typeName + " - " + act.name, id: act.id }))
                    this.roleName = reqActions.data.role
                }
                catch (e) {
                    console.error(e)
                }

            },
            onDropAction(collection, dropResult) {
                    this[collection] = this.applyDrag(this[collection], dropResult)
            },
            async onDropAssignedAction(collection, dropResult) 
            {
                try {
                    const actionSecurityPostObj = {
                        RoleId: this.roleId,
                        Id: dropResult.payload.id,
                        IsAssigned: dropResult.removedIndex != undefined ,
                        UserId: this.userId
                    }
                    const req = await axios.post(`${constants.baseApiUrl}ActionSecurity/AssignAction`, actionSecurityPostObj)
                    if (req.status === 200) {
                        if(req.data === 1) { //Already assigned
                            window.showAlert("Already assigned", 'success');
                        }
                        else if(req.data === 2) { //Remove assigned action
                            window.showAlert(`Removed action: ${dropResult.payload.data}`, 'success');
                        }
                        else if(req.data === 3) { //Added assigned action
                            window.showAlert(`Added action: ${dropResult.payload.data}`, 'success');
                        }
                            this[collection] = this.applyDrag(this[collection], dropResult)
                    }
                }
                catch (e) {
                    console.error(e)
                }
            },
            applyDrag(arr, dragResult) {
                const { removedIndex, addedIndex, payload } = dragResult
                if (removedIndex === null && addedIndex === null) return arr

                const result = [...arr]
                let itemToAdd = payload
                
                if (removedIndex !== null) {
                    itemToAdd = result.splice(removedIndex, 1)[0]
                }

                if (addedIndex !== null) {
                    result.splice(addedIndex, 0, itemToAdd)
                }

                return result
            },
            getChildPayload1(index) {
                return this.actions[index];
            },

            getChildPayload2(index) {
                return this.assignedActions[index];
            },
        }
    };
</script>

<style scoped>
    .list-box {
        border: 1px solid #ccc;
        border-radius: 5px;
        max-height: 300px;
        overflow-y: auto;
    }

    .draggable-item { padding: 10px;
        border-bottom: 1px solid #eee;
        background-color: #f9f9f9;
        transition: background-color 0.3s ease;
    }

    .draggable-item:last-child {
        border-bottom: none;
    }

    .draggable-item:hover {
        cursor: pointer;
        background-color: #e5e5e5;
    }
</style>